export default function initStartVideo() {
    const videos = document.querySelectorAll("[data-video]")

    videos.forEach((video) => {

        const startVideo = Array.from(video.children)
        startVideo[0].addEventListener("click", (e) => {
            let videoWrap = e.target.closest('[data-video]')
            let video = videoWrap.querySelector('iframe')
            let videoUrl = video.getAttribute('src')
            videoUrl += "?autoplay=1";
            video.setAttribute('src', videoUrl);
            videoWrap.classList.add('hide')
        })
    })
}


// WEBPACK FOOTER //
// ./src/js/startVideo.js